import React from 'react';

import { RenderElementProps } from 'slate-react';

import type { AlignType, CustomElement } from './EditorTextArea.types';
import { isAlignElement } from './EditorTextArea.utils';

const Element = ({ attributes, children, element }: RenderElementProps) => {
  const customElement = element as CustomElement;
  const style: React.CSSProperties = {};

  if (isAlignElement(customElement)) {
    style.textAlign = customElement.align as AlignType;
  }

  if ('indent' in customElement && customElement.indent) {
    style.paddingLeft = `${customElement.indent * 2}em`;
  }

  switch (customElement.type) {
    case 'list-content-wrapper':
      return children;
    case 'link':
      return (
        <a style={style} {...attributes}>
          {children}
        </a>
      );
    case 'ul':
      return (
        <ul style={style} {...attributes}>
          {children}
        </ul>
      );
    case 'li':
      return (
        <li style={style} {...attributes}>
          {children}
        </li>
      );
    case 'ol':
      return (
        <ol style={style} {...attributes}>
          {children}
        </ol>
      );
    default:
      return (
        <p style={style} {...attributes}>
          {children}
        </p>
      );
  }
};

export default Element;
